// Local, optional interactions; the article remains readable without JavaScript.
const chapters=[...document.querySelectorAll('.difference')];
const indexLinks=[...document.querySelectorAll('.story-index a')];
const segments=[...document.querySelectorAll('.reading-segments i')];
const progress=document.querySelector('.progress');
const sticky=document.querySelector('.sticky-offer');
const mobileReading=document.querySelector('.mobile-reading');
const offers=[...document.querySelectorAll('[data-offer]')];
let queued=false;
function updateReading(){
  const max=document.documentElement.scrollHeight-innerHeight;
  progress.style.width=`${max>0?Math.min(100,Math.max(0,scrollY/max*100)):0}%`;
  let current=0;
  chapters.forEach((section,i)=>{if(section.getBoundingClientRect().top<innerHeight*.38)current=i;});
  indexLinks.forEach((link,i)=>{link.classList.toggle('active',i===current);if(i===current)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});
  segments.forEach((seg,i)=>seg.classList.toggle('on',i<=current));
  document.querySelector('#current-difference').textContent=`0${current+1} / 07 · ${chapters[current].dataset.short}`;
  const started=chapters[0].getBoundingClientRect().top<90;
  const inArticle=chapters.at(-1).getBoundingClientRect().bottom>60;
  mobileReading.classList.toggle('visible',started&&inArticle);
  const busy=offers.some(el=>{const r=el.getBoundingClientRect();return r.top<innerHeight&&r.bottom>0;});
  const show=started&&!busy;
  sticky.classList.toggle('visible',show);sticky.inert=!show;
}
addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(()=>{updateReading();queued=false;});}},{passive:true});
addEventListener('resize',updateReading);
document.querySelectorAll('img').forEach(img=>img.addEventListener('load',updateReading,{once:true}));
const readingText=document.querySelector('.difference-body').textContent;
document.querySelector('#reading-time').textContent=`${Math.ceil(readingText.trim().split(/\s+/).length/220)} min de lectura`;
const crushButton=document.querySelector('#crush-button');
crushButton.addEventListener('click',()=>{
  const crushed=crushButton.getAttribute('aria-pressed')!=='true';
  crushButton.setAttribute('aria-pressed',String(crushed));
  document.querySelector('#crush-lab').classList.toggle('is-crushed',crushed);
  document.querySelector('#crush-label').textContent=crushed?'Se forma alicina':'Un diente entero';
  document.querySelector('#crush-title').innerHTML=crushed?'Ese aroma<br>tiene química.':'La sorpresa<br>está dentro.';
  crushButton.innerHTML=crushed?'Volver a ver el diente <span aria-hidden="true">↺</span>':'Aplastar el diente <span aria-hidden="true">↗</span>';
});
const shelf=document.querySelector('.aging-shelves');
for(let i=0;i<24;i++){const jar=document.createElement('span');jar.className='aging-jar';shelf.append(jar);}
const stages=[
  {number:'01',unit:'punto de partida',title:'Todo comienza en la misma planta.',description:'El ajo fresco es la materia prima. La preparación que viene después define el tipo de producto.'},
  {number:'→',unit:'una transformación',title:'El proceso cambia la composición.',description:'El añejamiento y la extracción modifican el conjunto de compuestos. Esta ilustración representa el proceso, no una medición de laboratorio.'},
  {number:'24',unit:'meses declarados',title:'Dos años, antes de llegar a ti.',description:'Ese es el tiempo de añejamiento que declara Nativo. Describe la elaboración; no un plazo para notar resultados.'}
];
document.querySelectorAll('.stage-controls button').forEach(button=>button.addEventListener('click',()=>{
  const n=Number(button.dataset.stage),stage=stages[n];
  document.querySelector('.aging-room').dataset.stage=String(n);
  document.querySelectorAll('.stage-controls button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  document.querySelector('#aging-number').textContent=stage.number;
  document.querySelector('#aging-unit').textContent=stage.unit;
  document.querySelector('#stage-title').textContent=stage.title;
  document.querySelector('#stage-description').textContent=stage.description;
}));
document.querySelectorAll('[data-answer]').forEach(button=>button.addEventListener('click',()=>{
  document.querySelectorAll('[data-answer]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
  const answer=document.querySelector('#puzzle-answer');
  const correct=button.dataset.answer==='unknown';
  answer.innerHTML=`<b>${correct?'Exacto. El aspecto no alcanza.':'Es tentador elegir por el color.'}</b><p>La respuesta es la misma para A y B: sin saber qué preparación contienen, no podemos identificarlas. Polvo, aceite y extracto añejado son presentaciones distintas, aunque se parezcan por fuera.</p>`;
  answer.hidden=false;
}));
const params=new URLSearchParams(location.search);
const allowed=['utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id','fbclid'];
document.querySelectorAll('[data-product-link]').forEach(link=>{const url=new URL(link.href);allowed.forEach(key=>{if(params.has(key))url.searchParams.set(key,params.get(key));});link.href=url.href;});
updateReading();
